export default __webpack_public_path__ + "images/Zippyy-Logo.svg";